﻿import {Store} from "@2d-front-monorepo/core";
import {Context, createContext, JSX} from 'react';

export type AuthStatus = "logged-in" | "unauthorized";

export type UserState = {
	email: string;
	authStatus: AuthStatus;
}

export const userStore: Store<UserState> = new Store<UserState>({
	email: "",
	authStatus: "unauthorized"
});

export const UserContext:Context<Store<UserState> | null> = createContext<Store<UserState> | null>(null);

export function UserProvider({children}: { children: React.ReactNode }): JSX.Element {
	return (
		<UserContext.Provider value={userStore}>
			{children}
		</UserContext.Provider>
	);
}
